// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__lqcs7","placeHolderShimmer":"Navigation_placeHolderShimmer__YyMvj"};